import { Context, type Effect, Layer, type Option, type Scope } from "effect";
import type { RecordingInitialLinkFailure, RecordingReference } from "./initial-link-model.ts";

export class RecordingInitialLinkIo extends Context.Service<RecordingInitialLinkIo, {
  readonly parameter: Effect.Effect<unknown, RecordingInitialLinkFailure>;
}>()("workerstation/frontend/RecordingInitialLinkIo") {}
export const RecordingInitialLinkIoTest = (io: typeof RecordingInitialLinkIo.Service) => Layer.succeed(RecordingInitialLinkIo, io);
export interface RecordingInitialLinkSession {
  readonly reference: Option.Option<RecordingReference>;
  readonly receive: (ready: boolean, open: Effect.Effect<void, RecordingInitialLinkFailure>) => Effect.Effect<void, RecordingInitialLinkFailure>;
}
export class RecordingInitialLinks extends Context.Service<RecordingInitialLinks, {
  readonly open: Effect.Effect<RecordingInitialLinkSession, RecordingInitialLinkFailure, Scope.Scope>;
}>()("workerstation/frontend/RecordingInitialLinks") {}
export const RecordingInitialLinksTest = (service: typeof RecordingInitialLinks.Service) => Layer.succeed(RecordingInitialLinks, service);
